import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileType } from '../../models/file-type.model';
import { CustomNotificationService } from '../../services/custom-notification.service';

@Component({
    selector: 'spv2-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Input() files: File[];
  @Input() isSingleUpload = true;
  @Input() disabled = false;
  @Input() acceptedFileTypes: FileType[];
  @Output() filesChange = new EventEmitter<File[]>();

  acceptedFileTypesHtml: string;
  constructor(private notifactionService: CustomNotificationService) {
  }

  ngOnInit(): void {
    this.acceptedFileTypesHtml = this.acceptedFileTypes.map(x => `.${x.extension},${x.mimeTypes}`).join(",");
  }

  onFileDropped(files: File[]) {
    this.fileUploaded(files);
  }

  onFileUploaded(files: File[], input: HTMLInputElement) {
    this.fileUploaded(files);
    input.value = null;
  }

  fileUploaded(files: File[]) {
    if(this.disabled) return;
    if(!Array.from(files).every(file => this.acceptedFileTypes.some(type => type.mimeTypes.includes(file.type)))){
      this.notifactionService.warning("Invalid file type found");
      return;
    } 

    this.files = files;
    this.filesChange.emit(this.files);
  }
}
